import StyledContainer from "style/styledContainer"
import styled from "styled-components"
import {  Row } from "style/preset";
import { motion } from "framer-motion";


import cardOneLeft from "assets/images/light_spot_right.png";
import cardOneRight from "assets/images/light_spot_right.png";
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { setToAddress } from "hooks/redux/slices/coreInfoSlice";
import { useState } from "react";
import useBrc20Utils from "hooks/brc20/useBrc20Utils";

const Brc20ReclipAddrCom = () => {
  const { toAddress } = useAppSelector((state) => state.coreInfo)
    const [isFocus, setIsFocus] = useState(false)
    const dispatch = useAppDispatch()
    const { isBTC } = useBrc20Utils()


    const fnFocus = () => {
      setIsFocus(true)
    }

    const fnBlur = () => {
      setIsFocus(false)
    }

    /**
     * 修改值
     */
    const onValueChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
      const val = e.target.value.trim()
      dispatch(setToAddress(val))
    }

    return <Brc20ReclipAddrWrap>
        {
          isBTC && <>
            <AnimateImgLeftWrap
              src={cardOneLeft}
              animate={{
                bottom: ["-20px", "10px", "-20px"],
                left: ["0px", "10px", "0px"],
              }}
              transition={{
                duration: 6,
                ease: "easeInOut",
                repeat: Infinity,
              }}
            ></AnimateImgLeftWrap>
            <AnimateImgRightWrap
              src={cardOneRight}
              animate={{
                right: ["-20px", "0px", "-20px"],
                top: ["0px", "10px", "0px"],
              }}
              transition={{
                duration: 6,
                ease: "easeInOut",
                repeat: Infinity,
              }}
            ></AnimateImgRightWrap>
          </>
        }
        <Brc20AddrContentWrap $isFocus={isFocus}>
            <TopWrap>
                <Row $mb="12px" $justifyContent="space-between">
                    <StyledContainer $fontSize="14px" $lineHeight="16px">Recipient address</StyledContainer>
                </Row>
                <AddressTextAreaWrap placeholder="Start typing" value={toAddress} onFocus={fnFocus} onBlur={fnBlur} onChange={onValueChange}></AddressTextAreaWrap>
            </TopWrap>
        </Brc20AddrContentWrap>
    </Brc20ReclipAddrWrap>
}

const Brc20ReclipAddrWrap = styled(StyledContainer)`
    width: 100%;
    position: relative;
`

const ImgLeftWrap = styled.img`
  position: absolute;
  width: 106px;
  height: 109px;
  bottom: -20px;
  left: 0;
  transform: rotate(-330deg);
`;

const AnimateImgLeftWrap = styled(motion(ImgLeftWrap))``;

const ImgRightWrap = styled.img`
  position: absolute;
  width: 74px;
  height: 80px;
  top: 0;
  right: -10px;
`;
const AnimateImgRightWrap = styled(motion(ImgRightWrap))``;

const Brc20AddrContentWrap = styled(StyledContainer)<{$isFocus: boolean}>`
    background-color: ${({ theme }) => theme.basicWhite};
    position: relative;
    z-index: 1;
    border-radius: 9px;
    box-shadow: ${({$isFocus}) => $isFocus ? '0px 14px 64px -4px rgba(24, 39, 75, 0.12), 0px 8px 22px -6px rgba(24, 39, 75, 0.12) !important' : '0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08)'};
    &:hover {
      box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }
`
const TopWrap = styled(StyledContainer)`
    padding: 20px 20px 16px 20px;
`

const AddressTextAreaWrap = styled.textarea<any>`
    resize: none;
    height: 102px;
    width: 100%;
    border: none;
    outline: none;
    background-color: #F4F5F5;
    border-radius: 9px;
    padding: 20px;
    box-sizing: border-box;

    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    font-family: RoobertSemiBold;

    &::placeholder {
      color: #CACCCE;
    }
`

export default Brc20ReclipAddrCom